import {Component, Input, OnInit} from "@angular/core";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";
import {CloudflareService} from "../../../services/cloudflare.service";
import * as fromStore from '../../../../../../store';
import {Store} from "@ngrx/store";
import {FormControl} from "@angular/forms";
import {DbModalService} from "../../../../../../modules/modal/modal";
import {DbResponse} from "../../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../../shared/components/notifier/notification-type";
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";
import {filter, first} from "rxjs/operators";

@Component({
    selector: 'db-disable-cloudflare',
    templateUrl: './disable-cloudflare-enterprise.component.html',
    styleUrls: ['./disable-cloudflare-enterprise.component.scss'],
    standalone: false
})
export class DisableCloudflareEnterpriseComponent implements OnInit {

  @Input() websiteId: number;
  @Input() title: string;
  @Input() desc: string;
  @Input() negativeButtonText: string = 'Disable';
  @Input() positiveButtonText: string = 'Cancel';
  @Input() isActive: boolean = true;
  @Input() widthConfirmation: boolean;
  @Input() sizes: { width: number, height: number };
  @Input() forCancel: boolean = false;
  public loading: boolean;
  public checked: boolean = false;
  public agree: FormControl;

  constructor(
    private _dbModalService: DbModalService,
    private _activeModal: DbActiveModal,
    private _cloudflareService: CloudflareService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _store: Store<fromStore.DbStoreState>
  ) {
  }

  ngOnInit() {
    this.checked = !this.widthConfirmation;
    this.agree = new FormControl(this.checked);
    this._resize([this.sizes.height, this.sizes.width]);
  }

  private _resize(size: [number, number]): void {
    this._activeModal.resize(...size);
  }

  public close(): void {
    if (!this.isActive) {
      /*window['zE']('messenger', 'chat:removeTags', ['generic_support']);
      window['zE']('messenger', 'chat:addTags', ['open_livechat']);*/

      window['Smooch']?.open();
      /*window['zE']('messenger', 'chat:send', 'I need help with setting up Cloudflare');*/
      this._store.dispatch(new fromStore.ToggleChatOverlay(false));
    }
    this._activeModal.close();
  }

  public toggle(event) {
    this.checked = !!event.target.checked;
  }

  public disableCf(): void {
    this.loading = true;
    this._cloudflareService.disableCloudflare(this.websiteId)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      ).subscribe((response: DbResponse): void => {
        this.loading = false;
        if (response.success) {
          this.sendEvent();
          this._store.dispatch(new fromStore.LoadWebsites());
          this._store.dispatch(new fromStore.LoadUserSubscription());
          // this._store.dispatch(new fromStore.LoadCloudflareData(this.websiteId));
          NotifierComponent.notify(new Notification('Cloudflare Enterprise Disabled Successfully', NotificationType.SUCCESS));
        }
        else {
          NotifierComponent.notify(new Notification('Something Went Wrong...', NotificationType.DANGER));
        }
        this._activeModal.close();
      });
  }
  public sendEvent(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: this.forCancel ? 'Cancel button click': 'Disable button click (paid)',
      eventLabel: 'Cloudflare',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
